import { Flex, IconButton, Input, InputGroup, InputRightElement } from '@chakra-ui/react';

import { isDefined, isNotEmpty } from '@enterprise/core';
import { Xmark } from '@enterprise/ui';

import type { NthInputCellProps } from './types/nth-input-cell.props';

import { useNthInputCellConfiguration } from './hooks/nth-input-cell-configuration.hook';

const NthInputCell = ({ context, data, node, value }: NthInputCellProps) => {
  const { handleBlur, handleChange, handleClear, localValue } = useNthInputCellConfiguration({ context, data });

  if (node.level === -1) {
    return null;
  }

  return (
    <Flex
      align="center"
      gap={1}
      h="full"
      w="full">
      <InputGroup>
        <Input
          bg="white"
          className="hide-spin-buttons"
          lineHeight="initial!"
          max={data?.firstOutput}
          min={0}
          onBlur={handleBlur}
          onChange={handleChange}
          pattern="[0-9]*"
          placeholder="----"
          type="number"
          value={localValue}
        />
        {isDefined(localValue) && isNotEmpty(localValue) && (
          <InputRightElement>
            <IconButton
              aria-label="Clear value"
              icon={<Xmark />}
              onClick={handleClear}
              size="xs"
            />
          </InputRightElement>
        )}
      </InputGroup>
    </Flex>
  );
};

export default NthInputCell;
